const CITY_LABELS: Record<string, string> = {
  moscow: 'Москва',
  saint_petersburg: 'Санкт-Петербург',
  novosibirsk: 'Новосибирск',
  yekaterinburg: 'Екатеринбург',
  kazan: 'Казань',
  nizhny_novgorod: 'Нижний Новгород',
  chelyabinsk: 'Челябинск',
  krasnoyarsk: 'Красноярск',
  samara: 'Самара',
  ufa: 'Уфа',
  rostov_on_don: 'Ростов-на-Дону',
  omsk: 'Омск',
  krasnodar: 'Краснодар',
  voronezh: 'Воронеж',
  perm: 'Пермь',
  volgograd: 'Волгоград',
  saratov: 'Саратов',
  tyumen: 'Тюмень',
  tolyatti: 'Тольятти',
  izhevsk: 'Ижевск',
}

export const formatCityLabel = (city: string | null | undefined): string => {
  if (!city?.trim()) {
    return '—'
  }
  const normalized = city.trim().toLowerCase()
  return CITY_LABELS[normalized] ?? city
}
